import React from 'react'
import Youtubevideo from './Youtubevidoe'
import  Navbar  from '../inc/Navbar';


function Youtubepage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
         <br/>
        <br/>
        <br/>
         <div className="album py-1">
        <div className="container">
            <center>
            <h2 style={{ color: "#19514f" }}>Aqua Dimon RO-Youtube</h2>
            <p>Welcome to Aqua Dimon RO, your trusted destination for reliable RO Water Purifiers, Water Treatment Plants, RO Installation, Repair & Maintenance Services.

Aqua Dimon provides water purification solutions for homes, offices, commercial establishments and industrial requirements. The company is based in Berhampore, Murshidabad, West Bengal.</p>

          </center>
          </div>
        </div>
         <Youtubevideo/>
        <br/>
    </div>
  )
}

export default Youtubepage